import { AfterViewInit, Component, ElementRef, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy, input } from '@angular/core';
import {LineChartData} from '../../model/chart-data/line-chart.data';
import Chart from 'chart.js/auto';

@Component({
    selector: 'app-line-chart',
    templateUrl: './line-chart.component.html',
    styleUrls: ['./line-chart.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})
export class LineChartComponent implements AfterViewInit, OnChanges {

  readonly data = input.required<LineChartData>();
  @ViewChild('lineChart') private lineChartReference!: ElementRef;
  private chart!: Chart;

  ngAfterViewInit(): void {
    this.chart = new Chart(this.lineChartReference.nativeElement, {
      type: 'line',
      data: {
        labels: this.data().labels,
        datasets: this.data().datasets
      },
      options: {
        maintainAspectRatio: false,
        plugins: {
          legend: {
            display: false
          }
        },
        scales: {
          y: {
            beginAtZero: true
          }
        }
      }
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.chart) {
      this.chart.data.labels = this.data().labels;
      this.chart.data.datasets = this.data().datasets;
      this.chart.update();
    }
  }

}
